/**
 * FlipCard — reusable hover-to-flip card (Ticketor-inspired).
 *
 * Front / back faces both fill the card. On hover (desktop) or tap
 * (mobile — tracked via `flipped` state) the card rotates on Y-axis.
 * Backface visibility hidden so the reverse side stays clean.
 *
 * Usage:
 *   <FlipCard front={<Front/>} back={<Back/>} height={220} />
 *
 * Motion respects `prefers-reduced-motion`.
 */
import { useState } from "react";

export default function FlipCard({
  front,
  back,
  height = 220,
  className = "",
  testid,
}) {
  const [flipped, setFlipped] = useState(false);
  return (
    <div
      data-testid={testid}
      className={`hp-flip-card group ${className}`}
      style={{ perspective: "1200px", height: `${height}px` }}
      onClick={() => setFlipped((v) => !v)}
      onMouseLeave={() => setFlipped(false)}
    >
      <style>{`
        .hp-flip-card { position: relative; }
        .hp-flip-inner {
          position: relative; width: 100%; height: 100%;
          transform-style: preserve-3d;
          transition: transform 0.65s cubic-bezier(0.25, 0.8, 0.25, 1);
        }
        .hp-flip-card:hover .hp-flip-inner,
        .hp-flip-card.is-flipped .hp-flip-inner {
          transform: rotateY(180deg);
        }
        .hp-flip-face {
          position: absolute; inset: 0;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          border-radius: 0.75rem;
          overflow: hidden;
        }
        .hp-flip-back { transform: rotateY(180deg); }
        @media (prefers-reduced-motion: reduce) {
          .hp-flip-inner { transition: none; }
        }
      `}</style>
      <div className={`hp-flip-inner ${flipped ? "is-flipped" : ""}`}>
        <div className="hp-flip-face hp-flip-front">{front}</div>
        <div className="hp-flip-face hp-flip-back">{back}</div>
      </div>
    </div>
  );
}
